import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65); /* Slightly darker than CardModal's for focus */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; /* Higher than CardModal if it can be opened on top, or same if CardModal closes */
`;

export const Content = styled.div`
  background: #323940; /* Dark theme from CardModal */
  color: #B6C2CF;    /* Default text color from CardModal */
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  width: 450px;
  max-width: 90%;
  position: relative;
`;

export const Header = styled.h2`
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #B6C2CF;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px; /* Larger for better clickability */
  cursor: pointer;
  color: #B6C2CF;
  padding: 0;
  line-height: 1;

  &:hover {
    color: #FFFFFF; /* Brighter on hover */
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #B6C2CF;
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 16px;
  border: 1px solid #3B444C; /* Border from CardModal's darker elements */
  border-radius: 4px;
  background-color: #22272B; /* Input background from CardModal */
  color: #B6C2CF; /* Text color */
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #4c9aff; /* Focus color from CardModal */
    box-shadow: 0 0 0 1px #4c9aff;
  }

  option {
    background-color: #22272B;
    color: #B6C2CF;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px; /* Space between buttons */
  margin-top: 24px;
`;

export const StyledButton = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  ${props => props.primary && `
    background-color: #0079BF; /* Primary action color from CardModal */
    color: white;

    &:hover {
      background-color: #026AA7; /* Darker shade for hover */
    }

    &:disabled {
      background-color: #3B444C; /* Disabled state, similar to SidebarButton */
      color: #6B778C;
      cursor: not-allowed;
    }
  `}

  ${props => props.secondary && `
    background-color: #3B444C; /* Secondary/Cancel button, similar to SidebarButton */
    color: #B6C2CF;

    &:hover {
      background-color: #4C5A67; /* Slightly lighter/different hover for secondary */
    }
  `}
`;

export const ErrorMessage = styled.p`
  color: #FF5630; /* Error color, often red/orange */
  font-size: 13px;
  margin-top: -8px; /* Adjust spacing if needed */
  margin-bottom: 16px;
`;

export const LoadingMessage = styled.p`
  font-size: 14px;
  color: #B6C2CF;
  margin-bottom: 16px;
`;
